import React, { useEffect, useState } from 'react';
import {  Col, Row } from 'reactstrap';
import { useQuery } from 'react-query';
import CardItem from '../component/cardItem';
import Transaction from '../component/transaction';
import TurnOver from '../component/turnover';
import { getMetricsByBusIdPercountryCode } from "../../../developer/services/developerApi";
import useConvertedCurrency from '../../../../common/convert/ConvertCurrendy';
import dollardIcon from "../../../../assets/images/violet.png";
import twoRow from "../../../../assets/images/jaune.png";
import rowDown from "../../../../assets/images/vert.png";
import '../utils/style.css';
import { getAllMerchent, getBusinessDevelopperById } from '../../../admin/merchant/services/merchentApi';
import { getAllDevelopers, } from '../../../admin/business/services/developerApi';
import BusinessManagement from '../../../admin/business/pages/index';
import { getAverageMonthlyVolume, getRevenuAllMerchent, getRevenuByCountry, getStatsByMerchantId, PaxityInfo } from '../services/homeAdminApi';
import CardItemS from '../component/cardItemS';
import { getCountryMethods } from '../../../transactions/services/transactionApi';
import CountrySelect from '../component/countrySelect';
import CreateTransfertModal from '../component/CreateTransfertModal';
import ManagePayIn from '../component/managePayIn';
import { Select } from 'antd';
    const HomeAdmin = () => {
    const [selectedMarchand, setSelectedMarchand] = useState(null);
    const { isLoadingM, isErrorM, errorM, data: merchants } = useQuery("merchants", getAllMerchent);
    const { isLoadingR, isErrorR, errorR, data: revenus } = useQuery("revenus", getRevenuAllMerchent);
     const {  data: commissions } = useQuery("commissions", PaxityInfo);
    const { data: statsMerchant, isLoading: isLoadingMerchantStats } = useQuery(
    ["merchantStats", selectedMarchand],
    () => getStatsByMerchantId(selectedMarchand),
    {
      enabled: !!selectedMarchand, 
    }
  );
  const { isLoadingD, isErrorD, errorD, data: developers } = useQuery("developers", getAllDevelopers);
  const { isLoading, isError, error, data: stats } = useQuery("stats", getAverageMonthlyVolume);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [amount, setAmount] = useState(0);
  const busId = selectedBusiness?.id;
  const cc = selectedCountryCode;
  const { data: metrics, isLoading: isLoadingMetric, isError: isErrorMetric, error: errorMetric } = useQuery(
    ["metrics", busId, cc],
    () => getMetricsByBusIdPercountryCode(busId, cc),
    { enabled: !!busId && !!cc }
  );
  const { countryBalance } = metrics || {};
  const fromCurrency = selectedBusiness?.currency || "";
  const { convertedTurnOver, isLoading: isConvertLoading, isError: isConvertError, error: convertError } =
    useConvertedCurrency(amount, fromCurrency, toCurrency);
    //marchant
 const marchandsActifs = Array.isArray(merchants)
  ? merchants.filter((m) => m.active === true).length
  : 0;
  const activeMerchants = selectedMarchand ? statsMerchant?.activeMerchants : marchandsActifs;
  const pourcentageMActif = selectedMarchand
  ? ((statsMerchant?.activeMerchants*100)/marchandsActifs).toFixed(0)
  : merchants?.length
    ? ((marchandsActifs * 100) / merchants.length).toFixed(0)
    : 0;
    //nombre de business pour un marchand 
     const [merchantBusiness, setBusinessMerchant] = useState(null);
    useEffect(() => {
      const fetchBusinessMerchant = async () => {
        try {
          const data = await getBusinessDevelopperById(selectedMarchand);
          console.log("Réponse business marchand:", data);
          setBusinessMerchant(data);
        } catch (error) {
          console.error("Erreur lors du chargement du business du marchand :", error);
        }
      };
      if (selectedMarchand) {
        fetchBusinessMerchant();
      }
    }, [selectedMarchand]);
    //developer
    const activeBusinesses = selectedMarchand ? statsMerchant?.activeDeveloperAccounts : stats?.activeDeveloperAccounts;
    const pourcentageActifBusiness = selectedMarchand
    ? ((statsMerchant?.activeDeveloperAccounts*100)/merchantBusiness?.length).toFixed(0)
    : developers?.length
    ? ((stats?.activeDeveloperAccounts * 100) / developers.length).toFixed(0)
    : 0;
  //Volume moyen de transactions
  const activeMonthlyVolume = selectedMarchand ? statsMerchant?.averageMonthlyVolume : stats?.averageMonthlyVolume;
  //soldes marhands et un marchand
 const totalRevenue = selectedMarchand ? statsMerchant?.totalRevenue : stats?.totalRevenue
  const formatShortNumber = (value) => {
  const num = parseFloat(value);
  if (isNaN(num)) return "0";
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(1)}K`;
  return `${num}`;
};
 const { data: countriesList, isLoading: isLoadingCountry, isError: isErrorCountry } = useQuery("countries", getCountryMethods);
const [selectedCountry, setSelectedCountry] = useState("SN");
const [commissionCountry, setCommissionCountry]=useState(null);
const [loadingCommission, setLoadingCommission]=useState(null);
useEffect(() => {
  if (!selectedCountry) return;

  const loadCommission = async () => {
    try {
      setLoadingCommission(true);
      const data = await getRevenuByCountry(selectedCountry);
      setCommissionCountry(data); // selon ta structure API
    } catch (error) {
      console.error("Erreur commission :", error);
      setCommissionCountry(null);
    } finally {
      setLoadingCommission(false);
    }
  };

  loadCommission();
}, [selectedCountry]);
    const countryFlags = {
  SN: "https://flagcdn.com/w40/sn.png", // Sénégal
  CI: "https://flagcdn.com/w40/ci.png", // Côte d'Ivoire
  BF: "https://flagcdn.com/w40/bf.png", // Burkina Faso
  BJ: "https://flagcdn.com/w40/bj.png", // Bénin
  NE: "https://flagcdn.com/w40/ne.png", // Niger
  ML: "https://flagcdn.com/w40/ml.png", // Mali
  GN: "https://flagcdn.com/w40/gn.png", // Guinée
  TG: "https://flagcdn.com/w40/tg.png", // Togo
  CM: "https://flagcdn.com/w40/cm.png", // Cameroun
  CD: "https://flagcdn.com/w40/cd.png" , // RDC
  KE: "https://flagcdn.com/w40/ke.png", // KE
  NG: "https://flagcdn.com/w40/ng.png",  // ng
  GH: "https://flagcdn.com/w40/gh.png"//gh
};

 const [isModalOpenTransfert, setIsModalOpenTransfert] = useState(false);
  return (
   <div style={{ backgroundColor: '#FBFBFB', minHeight: '100vh', padding: '20px' }}>
    <div
  className="d-flex align-items-center  mb-2 mt-4"
  style={{ gap: "1rem" }}
>
  <div className="title-page m-0">Dashboard</div>
  <CountrySelect
        countriesList={countriesList}
        selectedCountry={selectedCountry}
        setSelectedCountry={setSelectedCountry}
        countryFlags={countryFlags}
      />
  </div>
   <Row className="mb-3">
      <Col  xs={12} sm={6} lg={4} className="mb-3">
    <CardItemS
    title={
    <div style={{ display: "flex", alignItems: "center",width: "100%"}}>
      <span>Commission totale</span>
      {/*<Button onClick={() => setIsModalOpenTransfert(true)} size="sm"   style={{  marginLeft: "auto", border:'#4379F2',backgroundColor:'#3761FF',fontSize: '14px',fontFamily: 'Poppins, sans-serif', fontWeight: 400, color: '#FFFFFF'}}>
       💸 Transférer
      </Button>*/ }      
    </div>
      }
      counterEnd={
            loadingCommission
              ? "Chargement..."
              : commissionCountry?.totalFees 
          }
           icon={dollardIcon}
          currency={revenus?.currency}
          isLoading={ loadingCommission}
          isError={isErrorMetric}
        />
        </Col>
        <Col  xs={12} sm={6} lg={4} className="mb-3">
          <CardItemS
            title="Commission disponible"
            badgeColor="#FFF3D6" 
            color="#E8AC1E"
            icon={twoRow}
             counterEnd={
            loadingCommission
              ? "Chargement..."
              : commissionCountry?.totalCommission
            }
            currency={countryBalance }
            isLoading={isLoadingMerchantStats || isLoadingMetric}
            isError={isErrorMetric}
          />
        </Col>
        <Col  xs={12} sm={6} lg={4} className="">
          <CardItem
            title="Volume moyen de transactions"
            badgeColor="#D9F7E8" 
            color="#41BD7E"
            icon={rowDown}
            customValue={`~${formatShortNumber(activeMonthlyVolume)} K/mois`}
            currency={countryBalance?.currency}
            isLoading={isLoadingMerchantStats || isLoadingMetric}
            isError={isErrorMetric}
          />
        </Col>
      </Row>
      <Select className='mb-3'
        showSearch
        allowClear
        placeholder="Tous les marchands"
        value={selectedMarchand}
        onChange={(value) => setSelectedMarchand(value || null)}
        style={{ width: 250 }}
        optionFilterProp="children"
      >
        <Select.Option value="">
          Tous les marchands
        </Select.Option>

        {Array.isArray(merchants) &&
          merchants.map((marchand) => (
            <Select.Option key={marchand.id} value={marchand.id}>
              {marchand.firstName} {marchand.lastName}
            </Select.Option>
          ))}
      </Select>
      <Row className="mb-3">
         <Col xs={12} sm={12} md={12} lg={8} className="mb-3">
          <TurnOver
            title={
              selectedMarchand 
                ? `Chiffre d’affaires -Marchand ${merchants.find((m) => m.id === selectedMarchand)?.firstName || ""} ${merchants.find((m) => m.id === selectedMarchand)?.lastName || ""}`
                : "Chiffre d’affaires global - Tous les marchands"

            }
            selectedBusiness={selectedBusiness}
            selectedMarchand={selectedMarchand}
            setAmountForHome={setAmount}
          />
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} className="mb-3">
          <Transaction  title={
              selectedMarchand 
                ? `Performances opérationnelles -${merchants.find((m) => m.id === selectedMarchand)?.firstName || ""} ${merchants.find((m) => m.id === selectedMarchand)?.lastName || ""}`
                : "Performances opérationnelles global - Tous les marchands"
            }
            selectedBusiness={selectedBusiness}
            selectedMarchand={selectedMarchand}
             />
        </Col>
      </Row>
      <Row>
          <Col lg={12}>
           <ManagePayIn 
           title={
              selectedMarchand 
            ? `Liste des transactions  par  marchand  -${merchants.find((m) => m.id === selectedMarchand)?.firstName || ""} ${merchants.find((m) => m.id === selectedMarchand)?.lastName || ""}`
            : "Liste des transactions "
            }
            selectedBusiness={selectedBusiness}
            selectedMarchand={selectedMarchand}
            data={merchantBusiness} 
           />
           </Col>
      </Row>
      <Row>
          <Col lg={12}>
           <BusinessManagement 
           title={
              selectedMarchand 
            ? `Business du marchand  -${merchants.find((m) => m.id === selectedMarchand)?.firstName || ""} ${merchants.find((m) => m.id === selectedMarchand)?.lastName || ""}`
            : "Chiffre d’affaires - Tous les marchands"
            }
            selectedBusiness={selectedBusiness}
            selectedMarchand={selectedMarchand}
            data={merchantBusiness} 
           />
           </Col>
      </Row>
       <CreateTransfertModal
          visible={isModalOpenTransfert}
          onClose={() => setIsModalOpenTransfert(false)}
          /> 
    </div>
  );
};

export default HomeAdmin;
